// extracted by mini-css-extract-plugin
export default {"containerr":"KnVMe","mobile":"UIes3","loader":"nr4vX","button":"cLnFk","loading":"GEFuX","full":"quGDe","rounded":"YggHi"};